import { useMemo, useCallback } from 'react';

import { Link } from 'core/cells/link';
import { Typography } from 'core/cells/typography';

import { useHistory, useLocale } from 'core/dna/routing';
import { useTranslations } from 'core/dna/translations';

import { TeacherTableItem } from 'modules/planner/dna/types/teacher';
import { useTeachers } from 'modules/planner/metabolism/use-teachers';

import PlannerUrls from 'modules/planner/routing/urls';

export interface ColAvailabilityProps {
  item?: TeacherTableItem;
}

export const ColAvailability = (props: ColAvailabilityProps) => {
  const { item } = props;
  const { texts } = useTranslations();
  const history = useHistory();
  const locale = useLocale();
  const { setSelectedTeachers } = useTeachers();

  const text = useMemo(() => {
    if (!item?.availabilityDefined) {
      return texts.planner.common.create;
    }
    return texts.planner.common.definedCountChange.one;
  }, [item, texts.planner]);

  const handleClick = useCallback(() => {
    if (item) {
      setSelectedTeachers([item.id]);
      history.push(PlannerUrls.teachersAvailability(locale));
    }
    return false;
  }, [history, item, locale, setSelectedTeachers]);

  return item ? (
    <Link onClick={handleClick}>
      <Typography>{text}</Typography>
    </Link>
  ) : (
    <span> </span>
  );
};
